<script>
import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'SatisfactionPieChart',
  extends: Pie,
  mixins: [reactiveProp],

  props: {
    chartData: { required: true, type: Object },
    options: { required: true, type: Object },
    chartId: { required: true, type: String }
  },

  mounted () {
    let countValues = this.chartData.datasets[0].data.length
    let totalValue = 0
    for (let i = 0; i < countValues; i++) {
      totalValue += this.chartData.datasets[0].data[i]
    }
    let labels = {
      datalabels: {
        formatter: function (value) {
          if (value === 0) {
            return ''
          }
          return Math.round(value * 100 / totalValue) + '%'
        }
      }
    }

    this.options.plugins = labels
    this.renderThat()
  },

  methods: {
    renderThat () {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/reports/charts/SatisfactionPieChart.vue